import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { backendUrl } from '../config';
import { useLanguage } from '../contexts/LanguageContext';

const ResetPasswordPage = () => {
  const { t } = useLanguage();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [tokenValid, setTokenValid] = useState(false);
  const navigate = useNavigate();

  // Parse access_token and type from URL hash or query parameters
  useEffect(() => {
    let accessToken, refreshToken, type;

    const urlParams = new URLSearchParams(window.location.search);
    accessToken = urlParams.get('access_token');
    refreshToken = urlParams.get('refresh_token');
    type = urlParams.get('type');

    if ((!accessToken || !type) && sessionStorage.getItem('supabaseHash')) {
      const hashParams = new URLSearchParams(
        sessionStorage.getItem('supabaseHash').replace(/^#/, '')
      );
      accessToken = hashParams.get('access_token');
      refreshToken = hashParams.get('refresh_token');
      type = hashParams.get('type');
    }

    

    if (accessToken && type === 'recovery') {
      setTokenValid(true);
      if (refreshToken) {
        supabase.auth.setSession({
          access_token: accessToken,
          refresh_token: refreshToken,
        }).catch((error) => {
          console.error('Session set error:', error);
          setError(t('failedToSetSession'));
        });
      } else {
        console.error('Missing refresh_token in recovery link');
        setError(t('invalidResetLink'));
      }
    } else {
      setError(t('invalidResetLink'));
    }
  }, [t]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (password.length < 8) {
      setError(t('passwordMinLength'));
      return;
    }
    if (password !== confirmPassword) {
      setError(t('passwordsDoNotMatch'));
      return;
    }
    setLoading(true);
    const { error: updateError } = await supabase.auth.updateUser({ password });
    setLoading(false);
    if (updateError) {
      setError(updateError.message || t('failedToResetPassword'));
    } else {
      // Mark has_password: true in backend
      const user = (await supabase.auth.getUser()).data.user;
      if (user && user.email) {
        fetch(`${backendUrl}/auth/mark-has-password`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: user.email })
        });
      }
      setSuccess(t('passwordUpdated'));
      setTimeout(() => navigate('/login'), 2000);
    }
  };

  return (
    <div style={{ 
      maxWidth: '420px', 
      margin: '96px auto',
      background: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
      padding: '2.5rem 2rem',
      textAlign: 'center'
    }}>
      <h2 style={{ 
        marginBottom: '24px',
        color: '#2c6e49',
        fontWeight: '600'
      }}>{t('resetPassword')}</h2>
      {error && <div style={{ color: '#e57373', marginBottom: '16px' }}>{error}</div>}
      {success && <div style={{ color: '#56ab2f', marginBottom: '16px' }}>{success}</div>}
      {tokenValid && !success && (
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder={t('newPassword')}
            value={password}
            onChange={e => setPassword(e.target.value)}
            style={{ 
              width: '100%', 
              padding: '0.8rem', 
              marginBottom: '12px', 
              borderRadius: '8px', 
              border: '1px solid #ccc', 
              fontSize: '1rem',
              fontFamily: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", sans-serif',
              boxSizing: 'border-box'
            }}
            autoFocus
          />
          <input
            type="password"
            placeholder={t('confirmNewPassword')}
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            style={{ 
              width: '100%', 
              padding: '0.8rem', 
              marginBottom: '20px', 
              borderRadius: '8px', 
              border: '1px solid #ccc', 
              fontSize: '1rem',
              fontFamily: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", sans-serif',
              boxSizing: 'border-box'
            }}
          />
          <button
            type="submit"
            className="btn btn-primary"
            style={{ 
              width: '100%', 
              padding: '0.9rem', 
              fontWeight: '600', 
              fontSize: '1.1rem', 
              borderRadius: '8px', 
              border: 'none', 
              background: 'linear-gradient(135deg, #a8e063 0%, #56ab2f 100%)',
              color: '#fff', 
              cursor: loading ? 'not-allowed' : 'pointer', 
              opacity: loading ? 0.7 : 1,
              boxShadow: '0 2px 8px rgba(86, 171, 47, 0.2)',
              transition: 'all 0.2s ease-in-out'
            }}
            disabled={loading}
          >
            {loading ? t('resetting') : t('resetPassword')}
          </button>
        </form>
      )}
      {!tokenValid && !success && (
        <div style={{ marginTop: '24px' }}>
          <a 
            href="/login" 
            className="btn btn-primary"
            style={{
              textDecoration: 'none',
              display: 'inline-block'
            }}
          >
            {t('backToLogin')}
          </a>
        </div>
      )}
    </div>
  );
};

export default ResetPasswordPage; 